@if (hasShowButton()) {
  <div [ngClass]="[widthFull ? 'w-100' : '']" class="cab-button block mr-5">
    <button
      (click)="onClick()"
      [class.d-flex]="icon"
      [disabled]="disabled"
      [ngClass]="customClass"
      [type]="type"
      [title]="title | translate"
      [placement]="tooltipPosition"
      [ngbTooltip]="tooltipText"
      class="btn d-flex w-100 justify-content-center btn-{{ styleType }} btn-{{
        size
      }} fw-bold border-0 btn-outline align-items-center"
    >
      @if (isPending) {
        <div
          class="loadingio-spinner-spinner-0qb0ddr5bwvb"
          style="margin-right: 5px"
        >
          <div class="ldio-ng4stnl1cgl">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      }
      @if (icon) {
        <app-keenicon
          [name]="icon"
          class="{{ isLightIcon ? 'fs-2 text-white' : 'fs-2' }}"
          style="padding-top: 5px"
          [type]="iconType"
        />
      }
      @if (samllicon) {
        <app-keenicon class="fs-3 me-2" name="file-up" />
      }
      @if (label) {
        <span [class.ms-2]="icon" [translate]="label" class="label"></span>
      }
    </button>
  </div>
}
